import styled from '@emotion/styled';
import { Iframe } from '@/ui';
import { IIframeSectionEntry } from '../../../../contentful/types/IIframeSection';
import { Section } from './Section';

interface IIframeSectionProps {
	section: IIframeSectionEntry;
}

export function IframeSection({ section }: IIframeSectionProps) {
	return (
		<StyledSection height={section.fields.height}>
			<Iframe
				url={section.fields.url}
				maxWidth={section.fields.width}
				maxHeight={section.fields.height}
			/>
		</StyledSection>
	);
}

const StyledSection = styled(Section)<{ height: number }>`
	> div {
		height: ${({ height }) => `${height}px`};
	}
`;
